// @ts-nocheck
import React from 'react';
import KwPanel from '../../../common/KwPanel';
import FormInput from '../../../common/FormInput';
import FormColourPicker from '../../../common/FormColourPicker';
import FormTextArea from '../../../common/FormTextArea';
import { useTranslation } from 'react-i18next';

const TerritoryForm = ({ territory, register, errors, control }) => {
  const { t } = useTranslation();
  return territory ? (
    <KwPanel className="mb-4 pb-3 pt-2" testId="territory-details-panel">
      <FormInput
        register={register}
        required={true}
        error={errors.name}
        errorMessage={t('Required')}
        name="name"
        label={t('Name')}
        defaultValue={territory.name || ''}
        autoFocus={true}
        testId="territory-name"
      />

      <FormTextArea
        register={register}
        error={errors.register}
        name="description"
        label={t('Description')}
        placeholder={t('Enter a description')}
        defaultValue={territory.description || ''}
        testId="territory-description"
      />

      <FormColourPicker
        control={control}
        name="colourHex"
        label={t('Colour')}
        extraRowClasses="align-items-start"
        defaultValue={territory.colourHex || 'transparent'}
        testId="territory-colour"
      />
    </KwPanel>
  ) : (
    <></>
  );
};



export default TerritoryForm;
